// hooks/useFeatureFlag.ts
/**
 * Reads one account-level feature flag from the auth session.
 *
 * Flags are defined in the backend registry
 * (`api/constants/feature_flag_registry.py`) and delivered on the session as
 * `activeAccount.featureFlags`. The effective value is already resolved
 * server-side (superadmin-enabled AND account-active), so this is a plain
 * lookup — never combine it with a second client-side condition.
 *
 * A missing key reads as `false`: a flag the backend has not sent is one this
 * account does not have. Gating on `=== true` rather than truthiness means an
 * unknown flag can never accidentally open a feature.
 *
 * This is presentation gating only. Anything that must not be *reachable*
 * needs a server-side check as well.
 */

import { useAuth } from "@/context/AuthContext";

export function useFeatureFlag(key: string): boolean {
  const { activeAccount } = useAuth();
  return activeAccount?.featureFlags?.[key] === true;
}
